<template>
  <div class="user_authorization">
    <span>{{ $t('meta_title.user_authorization') }}</span>

    <div class="ibox-content">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>{{ $t('meta_title.actions') }}</th>
            <th v-if="user">
              {{ user.firstname }} {{ user.lastname }}
            </th>
          </tr>
        </thead>

        <tbody>
        <tr v-for="(authorization, key) in authorizations">
          <td>
            {{ $t('authorization.feature.' + extract_feature(key))
            }} - {{ $t('authorization.action.' + extract_action(key)) }}
          </td>
          <td v-if="user"
              :data-value="authorization.authorized !== null ? authorization : 0"
              data-authorization_type="user"
              :data-id="user.id"
              :data-feature="extract_feature(key)"
              :data-action="extract_action(key)"
              data-url="authorization_add_update"
              @click="changeState($event)">
            <span v-if="authorization && authorization === true">V</span>
            <span v-else>X</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'UserAuthorization',
    data() {
      return {
        authorizations: [],
        user: [],
      }
    },
    methods: {
      extract_feature(key){
        return key.split('_')[0];
      },
      extract_action(key){
        return key.split('_')[1];
      },
      changeState($event){
        let $elem = $event.currentTarget;

        this.$http.post('authorization', {
          type: $elem.dataset.authorization_type,
          id: $elem.dataset.id,
          action: $elem.dataset.action,
          feature: $elem.dataset.feature,
          value: $elem.dataset.value
        }, {
          redirectOnFailure: {name: 'UserAuthorization', params: {id: this.$route.params.id}}
        })
          .then(response => {
            $elem.dataset.value = response.data.authorized == true ? 1 : 0;
            $elem.textContent   = response.data.authorized == true ? 'V' : 'X';
          })
      }
    },
    created() {
      this.$http.get('user/' + this.$route.params.id + '/authorization')
        .then(response => {
          this.user           = response.data.user
          this.authorizations = response.data.authorizations
        })
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/User/authorization.vue